export default __webpack_public_path__ + "static/media/unicorn_mohawk.a79fdcc6.png";